var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E8F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.845 20.5631C10.995 21.6767 11.9173 22.549 13.0396 22.6006C13.984 22.644 14.9434 22.6667 15.9998 22.6667C17.0563 22.6667 18.0156 22.644 18.96 22.6006C20.0824 22.549 21.0047 21.6767 21.1546 20.5631C21.2525 19.8365 21.3332 19.0917 21.3332 18.3333C21.3332 17.5749 21.2525 16.8302 21.1546 16.1035C21.0047 14.99 20.0824 14.1177 18.96 14.0661C18.0156 14.0226 17.0563 14 15.9998 14C14.9434 14 13.984 14.0226 13.0396 14.0661C11.9173 14.1177 10.995 14.99 10.845 16.1035C10.7472 16.8302 10.6665 17.5749 10.6665 18.3333C10.6665 19.0917 10.7472 19.8365 10.845 20.5631Z",
    stroke: "#2E77D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.0002V12.3335C13 10.6766 14.3431 9.3335 16 9.3335C17.6569 9.3335 19 10.6766 19 12.3335V14.0002",
    stroke: "#2E77D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 19.6667V18.6667C13.3335 17.1939 14.5274 16 16.0002 16C17.4729 16 18.6668 17.1939 18.6668 18.6667V19.6667",
    stroke: "#2E77D0",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.6665V18.6665C15 18.1142 15.4477 17.6665 16 17.6665C16.5523 17.6665 17 18.1142 17 18.6665M17 20.6665V19.9998",
    stroke: "#2E77D0",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.8ddff14aa3b7590d907c20c41446d06c.svg";
export { ForwardRef as ReactComponent };